type DateEntryWithEndTime = readonly [string, ReadonlyArray<{ endDateTime: string }>];

export const getDefaultUpcomingDateLabel = (entries: ReadonlyArray<DateEntryWithEndTime>): string => {
  if (entries.length === 0) {
    return '';
  }

  const nowDateInMs = Date.now();
  let defaultSelectedDate = entries[0][0];
  let selectedDateAlreadySet = false;

  entries.forEach(([pillLabel, slots]) => {
    const lastSlot = slots[slots.length - 1];
    const endDateInMs = new Date(lastSlot.endDateTime).getTime();
    if (endDateInMs > nowDateInMs && !selectedDateAlreadySet) {
      defaultSelectedDate = pillLabel;
      selectedDateAlreadySet = true;
    }
  });

  return defaultSelectedDate;
};
